module.exports = __webpack_public_path__ + "img/logo.3e724b7d.png";